import ContentCreator from "../../../components/ContentCreator/ContentCreator";
import StudentModal from "../../../components/StudentModal/StudentModal";
import TanStackTable from "../../../components/Table/TanStackTable/TanStackTable";
import { useSalesSubscriptions } from "../../../hooks/Sales/SalesSubscriptions/useSalesSubscriptions";

export default function SalesSubscriptions() {

   const {
      displayForm,
      setDisplayForm,
      initialValuesEdit,
      setInitialValuesEdit,
      subscriptionData,
      loading,
      columns,
      modalOpen,
      setModalOpen,
      studentData,
      editSubscription,
      handleSetInitialValuesCreate,
      FORM_CONFIG,
      getFormAndPreview,
      handleSubmit,
   } = useSalesSubscriptions();

   return (
      <div className="salesPayments__container">
         {displayForm !== FORM_CONFIG.NONE && (
            <ContentCreator
               title={displayForm === FORM_CONFIG.EDIT ? "Detalles de la suscripción" : "Agregar suscriptor"}
               submitFunc={(values) => handleSubmit(values)}
               onCancel={() => {
                  setDisplayForm(FORM_CONFIG.NONE);
                  setInitialValuesEdit(null);
               }}
               initialValues={initialValuesEdit ?? null}
               renderPreview={() => <></>}
               renderForm={(_form) => getFormAndPreview("FORM", _form.form)}
            />
         )}
         {subscriptionData && (
            <TanStackTable
               loading={loading}
               data={subscriptionData}
               columns={columns}
               displayForm={displayForm !== FORM_CONFIG.NONE}
               editFunc={editSubscription}
               //   actionsFunc={(rowData) => editPaymentStateAction(rowData)}
               addButtonFunc={() => {
                  setDisplayForm(FORM_CONFIG.CREATE);
                  handleSetInitialValuesCreate();
                  if (displayForm !== FORM_CONFIG.NONE) setInitialValuesEdit(null);
               }}
            />
         )}
         {modalOpen && studentData && (
            <StudentModal
               open={modalOpen}
               setOpen={setModalOpen}
               studentData={studentData}
            />
         )}
      </div>
   )
}